<template>
  <div class="c-icon-ranking-other">
    {{ num }}
  </div>
</template>

<script>
export default {
  props: {
    num: {
      type: Number
    }
  }
};
</script>

<style lang="scss" scoped>
.c-icon-ranking-other {
  font-size: rem(15);
  width: rem(26);
  height: rem(26);
  border: rem(3) solid $common-gray500;
  border-radius: 50%;
  color: $common-gray500;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 900;
  text-align: center;
  line-height: rem(26);
}
</style>
